import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
export var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var designVersion = _ref.designVersion,
      visible = _ref.visible,
      sizeValue = _ref.sizeValue,
      debugMode = _ref.debugMode;
  return {
    rootStyle: {
      backgroundColor: visible || debugMode ? Colors.__backgroundAccentInline(designVersion).toString() : Colors.transparent(designVersion).toString(),
      minHeight: 10,
      width: sizeValue
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map